'use client';

import * as React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

import { cn } from '../../lib/utils';

/** Radio group, after glp-frontend `components/atoms/radio-group.tsx`. */
const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => (
  <RadioGroupPrimitive.Root ref={ref} className={cn('grid w-full gap-2', className)} {...props} />
));
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => (
  <RadioGroupPrimitive.Item
    ref={ref}
    className={cn(
      'peer relative flex aspect-square size-4 shrink-0 rounded-full border border-gray-500 bg-white outline-none focus-visible:ring-2 focus-visible:ring-global-green/40 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-global-green',
      className,
    )}
    {...props}
  >
    <RadioGroupPrimitive.Indicator className='absolute inset-0 flex items-center justify-center'>
      <span className='size-1/2 rounded-full bg-global-green' />
    </RadioGroupPrimitive.Indicator>
  </RadioGroupPrimitive.Item>
));
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
